<template>
    <div v-if="user" class="user-info-basic flex-row items-center p-relative">
        <div v-show="mouseOver" class="schedule-info badge">
            {{ `매칭 ${user.profile.match_count}` }}
        </div>
        <div v-if="user.name" class="w-100 flex items-center flex-wrap" :class="{ married: marry }">
            <div v-if="showLegacyUi" class="flex-row m-b-10">
                <div class="checkbox" :class="{ checked: this.fromRecruiter }" @click="onClickOnboard('recruiter')">
                    <i class="zmdi zmdi-check" v-if="this.fromRecruiter" />
                </div>
                <span class="m-l-5 m-r-15">리크루터 회원</span>
                <div class="flex">
                    <div class="flex-row items-center">
                        <div
                            class="btn m-r-8"
                            :class="{ selected: this.isFree === 'paid' }"
                            @click="onIsFreeClick('paid')"
                        >
                            유료회원
                        </div>
                        <div class="btn" :class="{ selected: this.isFree === 'free' }" @click="onIsFreeClick('free')">
                            무료회원
                        </div>
                    </div>
                    <div v-if="this.isFree === 'created'" class="red">유/무료 여부를 체크해주세요.</div>
                </div>
            </div>
            <div v-if="showLegacyUi" class="flex-row items-center m-b-10">
                <i @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" class="material-icons m-r-10"
                    >event_available</i
                >
                <div class="first flex-wrap" :class="{ married: marry, testUser }" v-html="userName" />
                <span
                    :class="{ married: marry }"
                    class="info flex-wrap"
                    v-html="
                        `${$options.filters.asAge(user.profile.birthday)}세 (${$moment(user.profile.birthday).format(
                            'YYYY'
                        )}년생)`
                    "
                />
            </div>
            <div v-if="showLegacyUi" class="flex-row items-center m-b-10">
                <span :class="{ married: marry }" class="info flex-wrap" v-html="`${user.profile.height}cm`" />
                <span :class="{ married: marry }" class="divider flex-wrap" v-html="'ㅣ'" />
                <span :class="{ married: marry }" class="info flex-wrap" v-html="user.profile.region_name" />

                <div class="badges-container flex-row flex-between">
                    <div class="badges flex-row flex-wrap items-center">
                        <div class="friend-functions flex-row items-center flex-wrap" v-if="chat && user.$$chatId">
                            <div class="divider m-l-8 m-r-8">|</div>
                            <div v-if="!hideBookmark" class="bookmark m-r-4" @click="onClickBookmark">
                                <img :src="bookmarkIcon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="showLegacyUi" class="flex-row m-b-10">
                <span :class="{ married: marry }" class="info flex-wrap" v-html="user.phone_number" />
            </div>

            <!-- <div v-if="isPanelFour" class="flex-row items-center w-100 m-b-10"> -->
            <div v-if="!showLegacyUi" class="flex-row items-center w-100 m-b-10">
                <div class="first flex-wrap" :class="{ married: marry, testUser }" v-html="userName2" />
                <LastSeen class="grow-0 m-l-4" :timestamp="user.last_sign_in_at" />

                <!-- introducing day -->
                <IntroDay
                    v-if="isPanelThree && user.introducing_day"
                    class="m-l-4 max-w-20"
                    :introducingDay="user.introducing_day"
                    :selected="true"
                    :canClick="false"
                    v-show="user.introducing_day"
                />
                <div v-if="isPanelThree && !user.introducing_day" class="m-l-4 max-w-20 text-nowrap c-red">N/A</div>

                <div class="user-action-continer">
                    <i @click="onClickControl()" class="material-icons-outlined">more_horiz</i>
                </div>
            </div>
            <!-- <div v-if="isPanelFour" class="flex-wrap items-center w-100 m-b-20"> -->
            <div v-if="!showLegacyUi" class="flex-wrap items-center w-100 m-b-20">
                <span
                    :class="{ married: marry }"
                    class="info flex-wrap"
                    v-html="`${$options.filters.asAge(user.profile.birthday)}<span class='f-regular'>세</span>`"
                />
                <!-- <span
                    :class="{ married: marry }"
                    class="info flex-wrap"
                    v-html="
                        `${$options.filters.asAge(user.profile.birthday)}세 (${$moment(user.profile.birthday).format(
                            'YY'
                        )}년생)`
                    "
                /> -->
                <span :class="{ married: marry }" class="divider flex-wrap" v-html="'ㅣ'" />
                <span
                    :class="{ married: marry }"
                    class="info flex-wrap"
                    v-html="`${user.profile.height}<span class='f-regular'>cm</span>`"
                />
                <span :class="{ married: marry }" class="divider flex-wrap" v-html="'ㅣ'" />
                <span :class="{ married: marry }" class="info flex-wrap" v-html="user.profile.region_name" />

                <div
                    v-if="!hideBookmark && !isPanelFour && !isPanelThree"
                    class="badges-container flex-row flex-between"
                >
                    <div class="badges flex-row flex-wrap items-center">
                        <div class="friend-functions flex-row items-center flex-wrap" v-if="chat && user.$$chatId">
                            <div class="divider m-l-8 m-r-8">|</div>
                            <div class="bookmark m-r-4" @click="onClickBookmark">
                                <img :src="bookmarkIcon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 여기에 상품 정보 :isPanelFour -->
            <div
                v-if="!showLegacyUi && userRatePlans && userRatePlans.length > 0"
                class="w-100 pre-line product-container f-medium m-b-10"
            >
                <span class="product" v-for="(plan, index) in newFilteredUserRatePlans" :key="plan.id">
                    <!-- {{ plan.name }}  -->
                    <!-- {{ plan.amount }}회{{
                        plan.price ? `| ${(plan.price / plan.amount_original).toLocaleString()}원` : null
                    }} -->
                    <span
                        v-html="
                            plan.ptype === 'rate_plan' ? '기간제' : plan.ptype === 'ticket_plan' ? '매칭권' : plan.name
                        "
                    />
                    <span
                        v-if="plan.ptype === 'ticket_plan'"
                        v-html="` (${user.tickets.filter(tic => tic.enabled === true).length}장)`"
                    />
                    <span
                        v-if="plan.ptype !== 'ticket_plan' && (plan.ptype !== 'rate_plan' || plan.id >= 500)"
                        v-html="
                            ` (${plan.status !== 'expired' ? `D-${plan.expire}` : `만료`}${
                                plan.ptype === 'subscription_plan' && !user.is_free ? ', 유료' : ''
                            })`
                        "
                    />
                    <span v-if="index != newFilteredUserRatePlans.length - 1" v-html="' / '" />
                </span>
            </div>

            <div v-if="showLegacyUi" class="m-b-10 f-15 f-medium">
                <div class="c-black m-b-10">
                    <!-- <span class="total-grade">종합: {{ user.profile.total_grade || 'null' }}</span> / 외모: -->
                    종합: {{ user.profile.total_grade || 'null' }} / 외모:
                    <!-- {{ lookGrade }} / 스펙: {{ user.profile.spec_score_admin || 'null' }} -->
                    {{ lookGrade }} / 스펙: {{ user.profile.spec_grade || 'null' }}
                </div>
                <div class="pre-line">
                    수락률: {{ user.user_info ? Math.round(user.user_info.accept_rate * 1000) / 10 + '%' : '0%' }} ({{
                        user.user_info ? user.user_info.photo_cnt : 0
                    }}장) / 피수락률:
                    {{ user.user_info ? Math.round(user.user_info.accepted_rate * 1000) / 10 + '%' : '0%' }} ({{
                        user.user_info ? user.user_info.photoed_cnt : 0
                    }}장) / 매칭계수:
                    {{
                        user.user_info && user.user_info.matching_coefficient
                            ? user.user_info.matching_coefficient === 0
                                ? '0.01(0)'
                                : user.user_info.matching_coefficient
                            : '0(신규)'
                    }}
                </div>
            </div>

            <div v-if="!showLegacyUi" class="w-100 m-b-10 f-15 f-medium">
                <div class="c-black m-b-10">
                    <!-- <span class="total-grade">종합: {{ user.profile.total_grade || 'null' }}</span> / 외모: -->
                    종합: {{ user.profile.total_grade || 'null' }} / 외모:
                    <!-- {{ lookGrade }} / 스펙: {{ user.profile.spec_score_admin || 'null' }} -->
                    {{ lookGrade }} / 스펙: {{ user.profile.spec_grade || 'null' }}
                </div>
                <div class="c-black pre-line">
                    수락률: {{ user.user_info ? Math.round(user.user_info.accept_rate * 1000) / 10 + '%' : '0%' }} ({{
                        user.user_info ? user.user_info.photo_cnt : 0
                    }}장) / 피수락률:
                    {{ user.user_info ? Math.round(user.user_info.accepted_rate * 1000) / 10 + '%' : '0%' }} ({{
                        user.user_info ? user.user_info.photoed_cnt : 0
                    }}장){{
                        isPanelThree
                            ? ` / 매칭계수: ${
                                  user.user_info && user.user_info.matching_coefficient
                                      ? user.user_info.matching_coefficient === 0
                                          ? '0.01(0)'
                                          : user.user_info.matching_coefficient
                                      : '0(신규)'
                              }`
                            : ''
                    }}
                </div>
            </div>
        </div>
        <div v-if="user.name" class="flex items-center flex-wrap" :class="{ married: marry }"></div>
    </div>
</template>

<script>
import userService from '@/services/user'

export default {
    name: 'UserInfoBasic',
    props: {
        user: {
            type: Object,
            required: true,
        },
        hideBookmark: {
            type: Boolean,
            default: true,
        },
        hideMemo: {
            type: Boolean,
            default: false,
        },
        isPanelThree: {
            type: Boolean,
            default: false,
        },
        isPanelFour: {
            type: Boolean,
            default: false,
        },
        userRatePlans: {
            type: [Function, Array],
            default() {
                return []
            },
            required: false,
        },
        showLegacyUi: {
            type: Boolean,
            default: false,
        },
        reloadUser: {
            type: Function,
            required: false,
        },
    },
    data: () => ({
        mouseOver: false,
        isDeposit: false,
        isFree: 'created',
        fromRecruiter: false,
    }),
    watch: {
        user() {
            this.setRecruiter
            this.setIsFree()
        },
        userRatePlans() {
            console.log('userRatePlans', this.userRatePlans)
        },
    },
    computed: {
        newFilteredUserRatePlans() {
            return this.userRatePlans.filter(item => {
                console.log('item', item)
                // love fit만 거르고 다 보여줌
                // return true
                if (item.pid === 210) {
                    return false
                }
                return true
            })
        },
        // filteredUserRatePlans() {
        //     return this.userRatePlans.filter(item => {
        //         console.log('item', item)
        //         if (item.ptype === 'subscription_plan') {
        //             return false
        //         }
        //         return true
        //     })
        // },
        testUser() {
            return (
                this.user.gender === 1 &&
                this.age <= 36 &&
                (this.user.profile.spec_rate || 0) >= 3 &&
                (this.user.profile.appearance_grade || 0) >= 3
            )
        },
        age() {
            if (!this.user.profile) return

            const birthday = this.user.profile.birthday
            if (!birthday) return

            return this.$options.filters.asAge(birthday)
        },
        userName() {
            return `${this.user.name}<span class='f-12'>(${this.user.id})</span>`
        },
        userName2() {
            return `${this.user.name}<span class='f-12'>(${this.user.id}, ${this.user.manager?.name})</span>`
        },
        height() {
            if (!this.user.profile) return

            return this.user.profile.height
        },
        userChat() {
            return (this.$store.getters.chatList || []).find(c => c.user_id === this.user.id)
        },
        chat() {
            return this.$store.getters.chat
        },
        bookmarkIcon() {
            return require(`@/assets/images/chatroom/chat_bookmark_${this.chat.bookmark ? 'active' : 'inactive'}.svg`)
        },
        marry() {
            return this.user.profile.marry
        },
        setRecruiter() {
            return (this.fromRecruiter = this.user.from_recruiter)
        },
        lookGrade() {
            if (this.user.profile.look_grade) {
                return this.user.profile.look_grade
            } else {
                return '평가 전'
            }
            // if (this.user.profile.look_grade === 0) {
            //     return 0
            // } else if (this.user.profile.look_grade === 1) {
            //     return 10
            // } else if (this.user.profile.look_grade === 2) {
            //     return 30
            // } else if (this.user.profile.look_grade === 3) {
            //     return 50
            // } else if (this.user.profile.look_grade === 4) {
            //     return 80
            // } else if (this.user.profile.look_grade === 5) {
            //     return 100
            // } else {
            //     return '평가 전'
            // }
        },
    },
    methods: {
        async onClickBookmark() {
            const bookmark = !this.chat.bookmark

            try {
                this.$loading(true)
                await this.$store.dispatch('bookmarkChat', { chat: this.chat, bookmark })
                this.$toast.success(`북마크${bookmark ? ' ' : '가 해제'}되었습니다`)
            } catch (e) {
                this.$toast.error(e.data)
            } finally {
                this.$loading(false)
            }
        },
        onMouseEnter() {
            this.mouseOver = true
        },
        onMouseLeave() {
            this.mouseOver = false
        },
        async onClickOnboard(status) {
            // console.log(status)
            try {
                const payload = {
                    status: status,
                    user_id: this.user.id,
                }
                const res = await userService.updateOnboardStatus(payload)
                if (status === 'recruiter') {
                    this.fromRecruiter = !this.fromRecruiter
                    this.$toast.success(res.msg)
                }
            } catch (e) {
                this.$toast.error(e.msg)
            }
        },
        async onIsFreeClick(isFree) {
            this.isFree = isFree
            const payload = {
                status: 'check_paid',
                user_id: this.user.id,
                is_free: isFree,
            }
            const res = await userService.updateOnboardStatus(payload)
            this.$toast.success(res.msg)
        },
        setIsFree() {
            this.isFree = this.user.is_free
        },

        async onClickControl() {
            console.log('this.user', this.user)
            const idx = await this.$modal.custom({
                component: 'ModalControlUserProfile',
                options: {
                    user: this.user,
                    hideMemo: this.hideMemo,
                    reloadUser: this.reloadUser,
                },
            })
            // console.log(idx)
            if (idx === 1) {
                // console.log(idx)
            } else if (idx === 2) {
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.user-info-basic {
    position: relative;
    width: 100%;
    .red {
        color: red;
        font-size: 12px;
        text-align: center;
    }
    .selected {
        background-color: #aaa;
        color: #fff;
    }
    .schedule-info {
        position: absolute;
        top: -20px;
        background: black;
        color: white;
    }
    .first,
    .info {
        // font-size: 18px;
        font-size: 16px;
        // margin-right: 4px;
        color: $black;
        @include f-bold;
    }
    .marry {
        font-weight: bold;
        font-size: 15px;
        line-height: 22px;
        color: #ffffff !important;
        background-color: #ff3d6b;
        margin: 0px 4px;
        border-radius: 4px;
        padding: 0px 4px;
    }

    .second {
        font-size: 12px;
        color: $grey-07;
    }

    .badges {
        margin-left: 8px;

        .snackbar {
            top: 32px;
        }
    }

    .divider {
        color: $grey-04;
    }

    .friend-functions {
        .bookmark {
            display: -webkit-box !important;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background-color: $grey-01;

            @include center;
        }
    }
    .married {
        color: #ff3d6b;
    }
    .testUser {
        color: $purple-primary;
    }
    .total-grade {
        color: $brand-accent;
    }

    .product-container {
        color: #13d30d;
    }
    .pre-line {
        white-space: pre-line;
    }

    .grow-0 {
        flex-grow: 0;
    }

    .max-w-20 {
        max-width: 20px;
    }

    .user-action-continer {
        text-align: right;
        font-size: 32px;
        color: black;
        padding-right: 16px;

        > i {
            font-size: 32px;
        }
    }
}

::v-deep .no-ons-campaign {
    &.third-panel {
        margin-top: 0;
        margin-left: 4px;
    }
}
</style>
